var map = {
	"./done_icon.json": 3482,
	"./error_icon.json": 6437,
	"./error_server.json": 2349,
	"./not-found-robot.json": 6899,
	"./robot_fly.json": 9177,
	"./robot_greeting.json": 7968,
	"./robot_running.json": 8968,
	"./robot_scan.json": 1580,
	"./robot_work_board.json": 7414,
	"./rocket_fly.json": 1315,
	"./server_working.json": 2780,
	"./server_working2.json": 1097,
	"./talk_call.json": 7749,
	"./team-talking.json": 4660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7221;